module.exports = __webpack_public_path__ + "static/media/CeraPro-Bold.f9bac5cd.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/cera/CeraPro-Bold.woff2
// module id = 170
// module chunks = 56